import React from "react"
import { Link } from "gatsby"

import footerMap from "../../images/footer-map.png"

import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  {
    strapiSiteLogo {
      image {
        url
        alternativeText
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(query)
  // console.log(data)
  const {
    strapiSiteLogo: { image },
  } = data

  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget">
              <Link to="/" className="logo">
                <img src={image.url} alt={image.alternativeText}/>
              </Link>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget pl-5">
              <h3>Inhalte</h3>

              <ul className="footer-links-list">
                <li>
                  <Link to="/">Start</Link>
                </li>
                <li>
                  <Link to="/ueber-uns">Über uns</Link>
                </li>
                <li>
                  <Link to="/referenzen">Referenzen</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget">
              <h3>Adresse</h3>

              <ul className="footer-contact-info">
                <li>
                  <i className="bx bx-map"></i>
                  Social Value GmbH für eine bessere Gesellschaft<br/>
                  Merheimer Straße 81<br/>
                  50733 Köln
                </li>
                <li>
                  <i className="bx bx-phone-call"></i>
                  <a href="tel:+4922167774683">0221 / 677 746 83</a>
                </li>
                <li>
                  <i className="bx bx-envelope"></i>
                  <a href="mailto:info@socialvalue.de">info@socialvalue.de</a>
                </li>
                <li>
                  <i className="bx bxl-linkedin-square"></i>
                  <a href="https://de.linkedin.com/company/social-value-gmbh-f-r-eine-bessere-gesellschaft" target="_blank">Folgen Sie uns bei LinkedIn</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom-area">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-12">
              <ul>
                <li>
                  <Link to="/datenschutzerklärung">Datenschutzerklärung</Link>
                </li>
                <li>
                  <Link to="/impressum">Impressum</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
